export var VEDIC_FORMAT_CURRENCIES=[];export var DEFAULT_TIMER_FORMAT="hMS";
//# sourceMappingURL=format.js.map